<script>

    export default {
        computed: {
            year() {
                return new Date().getFullYear()
            },
            homeURL() {
                return process.env.VUE_APP_HOMEPAGE
            }
        },

    }

</script>

<template>

    <footer class="footer">
        <div class="inner">
            <div>
                <img src="images/kog-logo.png" />
            </div>
            <div class="d-flex align-center footerContents">
                <p class="copyright">
                    © {{year}} KOG CORPORATION ALL RIGHTS RESERVED
                </p>
                <div  :class="{'mt-4' : $vuetify.display.smAndDown }">
                    <v-btn :class="{'ml-4' : $vuetify.display.smAndUp }"
                           variant="text"
                           color="#fe6175"
                           :size="$vuetify.display.smAndDown ? 'small' : 'large'"
                           :href="`${homeURL}privacy-policy`"
                           target="_blank">
                        PRIVACY POLICY
                    </v-btn>
                    <v-btn variant="text"
                           color="#fe6175"
                           :size="$vuetify.display.smAndDown ? 'small' : 'large'"
                           :href="`${homeURL}game/grandchaseclassic/EULA`">
                        TERMS OF USE
                    </v-btn>
                </div>

            </div>
        </div>

    </footer>

</template>

<style lang="scss">

    .footer {
        max-width: 2560px;
        background: #610b0c;
        color: #fff;
        width: 100%;
        text-align: center;
        border-top: solid 1px rgba(255,255,255,0.4);
        font-size: 14px;
        z-index: 0;
        margin: 20px auto 0;
        padding: 30px 10px;

        .inner {
            max-width: 1920px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
        }

        img {
            height: 40px;
        }

        .copyright {
            color: #fe6175;
            font-size: 16px;
        }
    }

    @media all and (max-width: 640px) {
        .footer {
            .inner {
                flex-direction: column;
                .copyright {
                    margin-top: 10px;
                    font-size: 12px;
                }
            }
        }
        .footerContents {
            flex-direction: column !important;
        }
    }

</style>